import { useMutation } from '@tanstack/react-query';

import { IMissionReport } from '@/interfaces/IMissionReport';

import api from '../services/api';

export const createMissionReport = ({
  unitId,
  data
}: {
  unitId: string;
  data: object;
}): Promise<{ data: { data: { mission_report: IMissionReport } } }> =>
  api.post(`/api/frontend/mission_reports`, { unit_id: unitId, data });

export const useCreateMissionReport = () => useMutation({ mutationFn: createMissionReport });
